import React from "react";
import {
  View,
  Text,
  TouchableOpacity,
  ScrollView,
  StyleSheet,
} from "react-native";

import { INTEGRATION_KEYS } from "../../IntegrationsHelper";
import {
  isWeb,
  isNativeApp,
  openURL,
  isAppleDevice,
} from "../../../../../helpers/utils";
import AppConfig from "../../../../../config/AppConfig";
import appStyles from "../../../../appStyles";
import GuidesIcon from "../../../common/icons/more/GuidesIcon";
import IntegrationIcons from "../../../common/icons/integrations";
import ManaIcon from "../../../common/icons/ManaIcon";
import steps from "../steps";
import styles from "../integrationStyles";

const DISABLE = true;

export default function CalendarIntegrationInfo({
  //isFromCard = false,
  goToStep = () => {},
  connect = () => {},
}) {
  return (
    <>
      <ScrollView
        style={(appStyles.scrollView, { paddingHorizontal: 16 })}
        contentContainerStyle={appStyles.scrollViewContent}
      >
        <Text style={styles.header}>Let’s connect!</Text>

        {/* Connect */}
        <View style={styles.section}>
          <Text style={styles.sectionHeader}>
            Once we connect to your calendar, we can:
          </Text>

          <View style={styles.row}>
            <IntegrationIcons.WandGradientIcon
              style={styles.icon}
              width={30}
              height={30}
            />

            <Text style={styles.rowText}>
              Automatically track calendar events, saving you hours of time lost
              to manual tracking
            </Text>
          </View>
          <View style={styles.row}>
            <IntegrationIcons.CalendarIcon
              style={styles.icon}
              width={30}
              height={30}
            />

            <Text style={styles.rowText}>
              Offer daily, weekly, monthly, and yearly overviews of where your
              time goes
            </Text>
          </View>
          <View style={styles.row}>
            <GuidesIcon style={styles.icon} width={30} height={30} />

            <Text style={styles.rowText}>
              Provide custom insights to help optimize how you spend time and
              achieve life-work balance
            </Text>
          </View>
        </View>

        {/* Safety */}
        <View style={styles.section}>
          <Text style={styles.sectionHeader}>Hold on, is this safe?</Text>

          <View style={styles.row}>
            <IntegrationIcons.DownloadIcon style={styles.icon} />

            <Text style={styles.rowText}>
              We only pull calendar events to track your time & never make
              changes to your calendars
            </Text>
          </View>
          <View style={styles.row}>
            <IntegrationIcons.PersonalIcon style={styles.icon} />

            <Text style={styles.rowText}>
              We secure your data with the same standards as a bank would secure
              your money
            </Text>
          </View>
          <View style={styles.row}>
            <IntegrationIcons.DollarIcon
              style={styles.icon}
              width={30}
              height={30}
            />

            <Text style={styles.rowText}>
              We’re not in the business of selling your data - that’s a promise
              that sets us apart.
            </Text>
          </View>

          <View style={styles.row}>
            <ManaIcon style={styles.icon} width={30} height={30} />

            <Text
              style={(styles.rowText, styles.link)}
              onPress={() => {
                openURL(AppConfig.PRIVACY_LINK);
              }}
            >
              Tap here for more on privacy at Mana
            </Text>
          </View>
        </View>
      </ScrollView>

      {/* Footer Buttons */}
      <View style={[appStyles.footerButtons, appStyles.verticalFooterButtons]}>
        <TouchableOpacity
          onPress={() => connect(INTEGRATION_KEYS.google)}
          style={[styles.button, customStyles.button]}
        >
          <IntegrationIcons.GoogleIcon
            style={customStyles.icon}
            width={22}
            height={22}
          />
          <Text style={customStyles.buttonText}>Sign in with Google</Text>
        </TouchableOpacity>

        {isWeb || AppConfig.DISABLE_MOBILE_CAL ? null : (
          <TouchableOpacity
            onPress={() => connect(INTEGRATION_KEYS.calendar)}
            style={[styles.button, customStyles.button]}
          >
            <IntegrationIcons.NativeCalendarIcon
              style={customStyles.icon}
              width={22}
              height={22}
            />
            <Text style={customStyles.buttonText}>
              Sign in with Mobile Calendar (ex. iCal)
            </Text>
          </TouchableOpacity>
        )}

        <Text
          style={styles.skipText}
          onPress={() =>
            goToStep(
              !isNativeApp()
                ? steps.desktop
                : isAppleDevice
                ? steps.health
                : steps.checklist,
            )
          }
        >
          Skip for now
        </Text>
      </View>
    </>
  );
}

const customStyles = StyleSheet.create({
  buttonText: {
    fontFamily: isWeb ? "Roboto" : "Montserrat",
    fontWeight: "500",
    fontSize: 12,
    lineHeight: 14,
    color: "#757575",
  },
  icon: {
    width: 30,
    height: 30,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: 20,
  },
  button: {
    backgroundColor: "#FFF",
    minWidth: 290,
    paddingHorizontal: 8,
    marginRight: 6,
    paddingLeft: 2,
  },
});
